/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  getProfile,
  updateProfile,
  disconnectCalendar,
  setCompany,
  setTrackingActivity,
  saveProfileImage,
} from '../../core/store/common/common'
import { validateUpdateProfile } from '../../shared/constants/patterns'

import { Profile } from '../../shared/components/Layout/Profile'
import moment from 'moment-timezone'
import {
  getUserInfo,
  showForAll,
  validEmails,
} from '../../shared/constants/utilities'
import { useNavigate } from 'react-router-dom'
import { Button, CircularProgress, IconButton, Switch } from '@mui/material'
import globals from '../../shared/constants/global.constant'
import styles from '../../shared/components/Layout/Layout.module.scss'
import { useMediaQuery } from 'react-responsive'
import { resetUsers } from '../../core/store/users/users'
import { resetTeams, resetTeamsTags } from '../../core/store/teams/teams'
import { logOut } from '../../core/store/login/auth'

export const ProfileResponsive = () => {
  const muaMobile = useMediaQuery({
    query: `(max-width: 480px)`,
  })
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { common, auth } = useSelector((state) => state)

  const {
    user,
    isSuccessSetCalendar,
    isSuccessUpdateUser,
    isLoadingUpdateUser,
    isLoadingUser,
    isSuccessTrackingActivity,
    isLoadingTrackingActivity,
    isSuccessSaveProfileImage,
  } = common

  const { isSuccessLogOut } = auth

  const [forceUpdate, setForceUpdate] = useState(false)
  const [profileAction, setProfileAction] = useState('profile')
  const [currentEmail, setCurrentEmail] = useState('')
  const [isTrackingActivity, setIsTrackingActivity] = useState(false)
  const [showTrakingMessage, setShowTrakingMessage] = useState(false)
  const [isTrackingActivityChecked, setIsTrackingActivityChecked] = useState(false)
  const [profileImage, setProfileImage] = useState(null)
  const [userInfo, setUserInfo] = useState({
    IsActiveNotification: true,
    TimeZone: { Name: '', Offset: '' },
    Calendar: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Id: '',
    IsTrackingActivity: false,
    Tier: '',
    DaysToUpdateTier: 0,
  })
  const [initialUserInfo, setInitialUserInfo] = useState({ ...userInfo })
  const [errorUserInfo, setErrorUserInfo] = useState({
    FirstName: {
      error: false,
    },
    LastName: {
      error: false,
    },
    TimeZone: {
      error: false,
    },
    Calendar: {
      error: false,
    },
    IsActiveNotification: {
      error: false,
    },
    Email: {
      error: false,
    },
  })

  const { id: userId, companyName, userName } = getUserInfo()

  useEffect(() => {
    if (user) {
      const {
        FirstName,
        LastName,
        Email,
        Id,
        TimeZone,
        Calendar,
        IsActiveNotification,
        ProfileImageUrl,
        IsTrackingActivity,
        Tier,
        DaysToUpdateTier,
      } = user
      const newUserInfo = {
        IsActiveNotification,
        TimeZone,
        Calendar: Calendar,
        FirstName: FirstName,
        LastName: LastName,
        Email: Email,
        Id: Id,
        IsTrackingActivity,
        Tier,
        DaysToUpdateTier,
      }
      setUserInfo(newUserInfo)
      setInitialUserInfo(newUserInfo)
      setCurrentEmail(Email)
      setProfileImage(ProfileImageUrl || null)
      setIsTrackingActivity(IsTrackingActivity)
    }
  }, [user])

  useEffect(() => {
    if (isSuccessLogOut) {
      navigate('/')
    }
  }, [isSuccessLogOut, navigate])

  const handleLogout = () => {
    dispatch(setCompany(null))
    dispatch(resetUsers())
    dispatch(resetTeams())
    dispatch(resetTeamsTags())
    dispatch(logOut())
    setForceUpdate(!forceUpdate)
  }

  useEffect(() => {
    if (isSuccessUpdateUser) {
      dispatch(getProfile(userId))
      setProfileAction('profile')
      if (currentEmail !== userInfo.Email) {
        handleLogout()
      }
      setErrorUserInfo({
        ...errorUserInfo,
        ProfileImageBase64: {
          error: false,
        },
      })
    }
  }, [isSuccessUpdateUser])

  useEffect(() => {
    if (isSuccessTrackingActivity) {
      setShowTrakingMessage(false)
      dispatch(getProfile(userId))
    }
  }, [isSuccessTrackingActivity])

  useEffect(() => {
    if (isSuccessSaveProfileImage) {
      dispatch(getProfile(userId))
    }
  }, [isSuccessSaveProfileImage])

  useEffect(() => {
    if (isSuccessSetCalendar) {
      dispatch(getProfile(userId))
      navigate('/')
      setProfileAction('profile')
    }
  }, [isSuccessSetCalendar])

  const handleUpdate = () => {
    setProfileAction('update')
  }

  const handleCloseUpdate = () => {
    setProfileAction('profile')
    dispatch(getProfile(userId))
  }

  const handleChange = (event) => {
    const { value, id } = event.target
    const newUserInfo = { ...userInfo }
    newUserInfo[id] = value
    setUserInfo(newUserInfo)
    const newErrorUserInfo = errorUserInfo
    newErrorUserInfo[id].error = false
    setErrorUserInfo(newErrorUserInfo)
    setForceUpdate(!forceUpdate)
  }

  const handleSelectCalendar = async (value) => {
    const newUserInfo = userInfo
    newUserInfo.Calendar = value === '1' ? 'Google' : 'Outlook'
    await setUserInfo(newUserInfo)
    dispatch(updateProfile(userId, userInfo))
    setForceUpdate(!forceUpdate)
  }

  const handleSelectNotification = (value) => {
    setUserInfo((prevUserInfo) => ({
      ...prevUserInfo,
      IsActiveNotification: value,
    }))
    setForceUpdate(!forceUpdate)
  }

  const handleSelectTimeZone = (selTimeZone) => {
    setUserInfo((prevUserInfo) => ({
      ...prevUserInfo,
      TimeZone: {
        Name: selTimeZone.id,
        Offset: moment.tz(selTimeZone.id).format('Z'),
      },
    }))
    setForceUpdate(!forceUpdate)
  }

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })
  }

  const handleSave = () => {
    const userInfoToValidate = {
      FirstName: userInfo.FirstName,
      LastName: userInfo.LastName,
      Id: userInfo.Id,
      Email: userInfo.Email,
      Calendar: userInfo.Calendar,
      TimeZone: userInfo.TimeZone,
      IsActiveNotification: userInfo.IsActiveNotification,
    }
    const validation = validateUpdateProfile.validate(userInfoToValidate, {
      abortEarly: false,
    })

    if (validation.error) {
      const newErrorUserInfo = errorUserInfo
      validation.error.details.forEach((ele) => {
        newErrorUserInfo[ele.context.label].error = true
        setErrorUserInfo(newErrorUserInfo)
        setForceUpdate(!forceUpdate)
      })
    } else {
      dispatch(updateProfile(userId, userInfo))
      setForceUpdate(!forceUpdate)
    }
  }

  const handleUploadImage = async (event) => {
    const file = event.target.files[0]

    if (file && file.type.startsWith('image/')) {
      setProfileImage(file)

      let base64Image = null

      if (file instanceof File) {
        const fullBase64 = await fileToBase64(file)
        base64Image = fullBase64.split(',')[1]
      }

      dispatch(
        saveProfileImage(userId, {
          ProfileImageBase64: base64Image,
          ProfileImageFileName: file.name,
        })
      )
    }
  }

  const handleDisconnect = () => {
    dispatch(disconnectCalendar())
  }

  const getTier = (tier) => {
    switch (tier) {
      case 'Starter':
        return 'starter'
      case 'Pro':
        return 'pro'
      case 'Master':
        return 'master'
      case 'Riser':
        return 'riser'
      default:
        return 'starter'
    }
  }

  const handleSwitch = (event) => {
    const { checked } = event.target
    setIsTrackingActivityChecked(checked)
    setShowTrakingMessage(true)
  }

  const handleTierNo = () => {
    setShowTrakingMessage(false)
  }

  const handleTierYes = () => {
    dispatch(setTrackingActivity(isTrackingActivityChecked))
  }

  const handleLearnMore = () => {
    const url = 'https://support.wemua.com/en/articles/11083346'
    window.open(url, '_blank')
  }

  const hasChanges = () => {
    const currentValues = {
      FirstName: userInfo.FirstName,
      LastName: userInfo.LastName,
      Email: userInfo.Email,
      TimeZone: userInfo.TimeZone?.Name,
      IsActiveNotification: userInfo.IsActiveNotification,
    }

    const initialValues = {
      FirstName: initialUserInfo.FirstName,
      LastName: initialUserInfo.LastName,
      Email: initialUserInfo.Email,
      TimeZone: initialUserInfo.TimeZone?.Name,
      IsActiveNotification: initialUserInfo.IsActiveNotification,
    }

    return JSON.stringify(currentValues) !== JSON.stringify(initialValues)
  }

  const isUserValid = validEmails.includes(userName) || showForAll
  return (
    <div
      className={styles.wrapperProfile}
      style={{
        justifyContent: profileAction === 'profile' && 'center',
        alignItems: profileAction === 'profile' && 'center',
      }}
    >
      {isLoadingUser ? (
        <CircularProgress size="20px" color="light" />
      ) : (
        <>
          {profileAction === 'profile' ? (
            <div className={styles.profileInfo}>
              <div className={styles.profileInfoHeader}>
                <div className={styles.imageContainer} onClick={handleUpdate}>
                  {profileImage !== null ? (
                    <img src={profileImage} alt="user" />
                  ) : (
                    <img
                      src={`${globals.imageBasePath}profile-image.png`}
                      alt="user"
                    />
                  )}
                </div>
                {isUserValid &&
                  (showTrakingMessage ? (
                    <div className={styles.tierMessageContainer}>
                      <div className={styles.tierMessageText}>
                        {isTrackingActivityChecked
                          ? 'Turning progress tracking on allows you to visualize your journey within MUA. Are you sure you\'d like to turn progress tracking on?'
                          : 'Are you sure you\'d like to turn progress tracking off?'}{' '}
                        <span
                          style={{
                            textDecoration: 'underline',
                            cursor: 'pointer',
                          }}
                          onClick={handleLearnMore}
                        >
                          learn more
                        </span>
                      </div>
                      <div className={styles.tierMessageButton}>
                        {isLoadingTrackingActivity ? (
                          <div className={styles.saveButtonWrapper}>
                            <CircularProgress
                              size="20px"
                              color="aqua"
                              sx={{ marginTop: '14px' }}
                            />
                          </div>
                        ) : (
                          <div className={styles.tierButtonsWrapper}>
                            <Button
                              onClick={handleTierNo}
                              className={styles.tierButtonNo}
                            >
                              <p>No</p>
                            </Button>
                            <Button
                              onClick={handleTierYes}
                              className={styles.tierButtonYes}
                            >
                              <p>Yes</p>
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className={styles.tierContainer}>
                      <img
                        src={`${globals.logosBasePath}${getTier(
                          userInfo.Tier
                        )}.svg`}
                        alt={getTier(userInfo.Tier)}
                        width="90%"
                        style={{
                          opacity: isTrackingActivity ? 1 : 0.4,
                        }}
                      />
                      <div className={styles.tierText}>
                        {isTrackingActivity
                          ? 'Stop tracking'
                          : 'Track progress'}
                        <Switch
                          onChange={handleSwitch}
                          checked={isTrackingActivity}
                          color="aqua"
                        />
                      </div>
                      {isTrackingActivity && (
                        <div className={styles.tierDays}>
                          {userInfo.DaysToUpdateTier === 0
                            ? 'Today is the update and it goes back to 14 days'
                            : `${userInfo.DaysToUpdateTier} days before next level update`}
                        </div>
                      )}
                    </div>
                  ))}
              </div>
              <div className={styles.userInfo}>
                <div className={styles.userEmail}>{companyName}</div>
                {userInfo.Calendar && (
                  <div className={styles.userEmail}>
                    {`Calendar: ${userInfo.Calendar} Calendar`}
                  </div>
                )}
                {userInfo.TimeZone?.Name && (
                  <div className={styles.userEmail}>
                    {`Time zone: ${userInfo.TimeZone?.Name}`}
                  </div>
                )}
                <div className={styles.wrapperUpdateButton}>
                  <Button
                    className={styles.updateButton}
                    onClick={handleUpdate}
                  >
                    <p>Edit Profile</p>
                  </Button>
                </div>
                <div className={styles.copyright}>
                  <img
                    src={`${globals.logosBasePath}copyright.svg`}
                    alt="copyright"
                  />
                  MUA 2025
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className={styles.updateIcon}>
                <IconButton onClick={handleCloseUpdate}>
                  <img
                    src={`${globals.logosBasePath}close-icon.svg`}
                    alt="close"
                    style={{ zIndex: 10 }}
                  />
                </IconButton>
              </div>
              <Profile
                isLoadingUpdateUser={isLoadingUpdateUser}
                handleSave={handleSave}
                handleDisconnect={handleDisconnect}
                handleChange={handleChange}
                handleSelectCalendar={handleSelectCalendar}
                handleSelectNotification={handleSelectNotification}
                handleSelectTimeZone={handleSelectTimeZone}
                userInfo={userInfo}
                errorUserInfo={errorUserInfo}
                muaMobile={muaMobile}
                handleUploadImage={handleUploadImage}
                currentEmail={currentEmail}
                setUserInfo={setUserInfo}
                hasChanges={hasChanges}
                profileImage={profileImage}
              />
            </>
          )}
        </>
      )}
    </div>
  )
}
